// SPV Pool v1.0 PR 6 — date-range resolution for the Cash Flow period
// selector. Kept in its own module so PeriodSelector.tsx only exports a
// component (React Fast Refresh constraint).

import type { CashFlowPeriod } from "@/types/spvPool";

function pad(n: number): string {
  return String(n).padStart(2, "0");
}

function iso(year: number, month: number, day: number): string {
  return `${year}-${pad(month + 1)}-${pad(day)}`;
}

/** Resolve the [start, end] ISO date range for `period` containing `now`. */
export function resolvePeriodRange(
  period: CashFlowPeriod,
  now: Date = new Date(),
): { start: string; end: string } {
  const year = now.getFullYear();
  const month = now.getMonth();

  if (period === "Annual") {
    return { start: iso(year, 0, 1), end: iso(year, 11, 31) };
  }
  if (period === "Quarterly") {
    const qStart = Math.floor(month / 3) * 3;
    const qEnd = qStart + 2;
    const lastDay = new Date(year, qEnd + 1, 0).getDate();
    return { start: iso(year, qStart, 1), end: iso(year, qEnd, lastDay) };
  }
  // Monthly (default)
  const lastDay = new Date(year, month + 1, 0).getDate();
  return { start: iso(year, month, 1), end: iso(year, month, lastDay) };
}
